<script>
    import { CardLayout } from "../../../Components/Common/index.svelte";
    import {
        getText,
        goToURL,
    } from "../../../Utils/utilFunctions.svelte";

    export let doctorDetails = {};

    // HELPER FUNCTIONS
    const _redirectToDoctor = () => {
        goToURL(`/Account/view/${doctorDetails.id}`);
    };

    const _getDoctorAddress = () => {
        const { address, city, state, postCode, country } =
            doctorDetails;

        const res = [];

        if (address) res.push(address);
        if (city) res.push(city);
        if (state) res.push(state);
        if (postCode) res.push(postCode);
        if (country) res.push(country);

        return res.join(", ");
    };
</script>

<CardLayout title="Doctor Details">
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Full Name:</p>
                <p
                    class="content cursor-pointer underline font-bold"
                    on:click|preventDefault={_redirectToDoctor}
                >
                    {doctorDetails.name}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Phone No.:</p>
                <p class="content">{getText(doctorDetails.phone)}</p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Mobile No.:</p>
                <p class="content">{getText(doctorDetails.mobile)}</p>
            </div>
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Email.:</p>
                <p class="content">{getText(doctorDetails.email)}</p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Location:</p>
                <p class="content">{_getDoctorAddress()}</p>
            </div>
        </div>
    </div>
</CardLayout>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
